import {Heading} from '@/components/heading';
import Aicon from '@/assets/icons/AIcon.svg';
export default function SectionBadge({text}: {text: string}) {
  return (
    <div className="border border-grey-2 rounded-full px-8 py-4 flex items-center gap-2">
      <Aicon className="h-6 w-6" />
      <Heading variant="h6">{text.toUpperCase()}</Heading>
    </div>
  );
}
